import { toString } from 'lodash-es';

interface PaymentProviderInterface {
  [key: string]: number;
}

interface PaymentProviderNameByIdInterface {
  [key: number]: string;
}

export const PaymentProvider: PaymentProviderInterface = {
  // multiplied by 100000 for different versions of the same provider and incremented by 1
  cash: 1,
  safecharge: 2,
  viva: 3,
  okto: 4,
  skrill: 5,
  abon: 6,
  bridger: 7,
  bridger_apple_pay: 700001,
  bridger_google_pay: 700002,
  betlion: 8, // channel_id = mobile
  betlion_mobile: 800000,
  betlion_unitel: 800001,
  betlion_telopay: 800002,
  betlion_afrimoney: 800003,
  betlion_ekwanza: 800004,
  betlion_aki: 800005,
  betlion_paypay: 800006,
  betlion_pagaso: 800007,
  betlion_multicaixa: 800008,
  betlion_express: 800009,
  // betlion_bai_account: 800010,
  // betlion_other_bank_account: 800011,
  betlion_paychangu: 800012,
  aircash_pay: 9,
};

export const PaymentProviderList = Object.values(PaymentProvider).map(toString);

export const PaymentProviderWithdraw: PaymentProviderInterface = {
  // needs matching with core
  viva: 3,
  iban: 4,
  skrill: 5,
  bridger: 7,
  bridger_apple_pay: 700001,
  bridger_google_pay: 700002,
  betlion: 8,
  betlion_unitel: 800001,
  betlion_telopay: 800002,
  betlion_afrimoney: 800003,
  betlion_ekwanza: 800004,
  betlion_aki: 800005,
  betlion_paypay: 800006,
  // betlion_pagaso: 800007,
  // betlion_multicaixa: 800008,
  // betlion_express: 800009,
  betlion_bai_account: 800010,
  betlion_other_bank_account: 800011,
  betlion_paychangu: 800012,
  aircash_pay: 9,
};

export const PaymentProviderWithdrawList = Object.values(PaymentProviderWithdraw).map(toString);

export const paymentProviderNameById: PaymentProviderNameByIdInterface = {
  [PaymentProvider.cash]: 'Cash',
  [PaymentProvider.safecharge]: 'Safecharge',
  [PaymentProvider.viva]: 'Viva',
  [PaymentProvider.bridger]: 'Bridger',
  [PaymentProvider.okto]: 'Okto',
  [PaymentProvider.abon]: 'Abon',
  [PaymentProvider.skrill]: 'Skrill',
  [PaymentProvider.betlion]: 'Betlion',
  [PaymentProvider.betlion_unitel]: 'Betlion-Unitel',
  [PaymentProvider.betlion_telopay]: 'Betlion-Telopay',
  [PaymentProvider.betlion_afrimoney]: 'Betlion-Afrimoney',
  [PaymentProvider.betlion_ekwanza]: 'Betlion-Ekwanza',
  [PaymentProvider.betlion_aki]: 'Betlion-Aki',
  [PaymentProvider.betlion_paypay]: 'Betlion-PayPay',
  [PaymentProvider.betlion_pagaso]: 'Betlion-Pagaso',
  [PaymentProvider.betlion_multicaixa]: 'Betlion-Multicaixa',
  [PaymentProvider.betlion_express]: 'Betlion-Express',
  [PaymentProvider.betlion_paychangu]: 'Betlion-PayChangu',
  [PaymentProvider.aircash_pay]: 'Aircash-Pay',
};

export const paymentProviderNameByWithdrawId: PaymentProviderNameByIdInterface = {
  [PaymentProviderWithdraw.viva]: 'Viva',
  [PaymentProviderWithdraw.skrill]: 'Skrill',
  [PaymentProviderWithdraw.iban]: 'IBAN',
  [PaymentProviderWithdraw.bridger]: 'Bridger',
  [PaymentProvider.bridger_apple_pay]: 'Bridger-ApplePay',
  [PaymentProvider.bridger_google_pay]: 'Bridger-GooglePay',
  [PaymentProviderWithdraw.betlion]: 'Betlion',
  [PaymentProviderWithdraw.betlion_unitel]: 'Betlion-Unitel',
  [PaymentProviderWithdraw.betlion_telopay]: 'Betlion-Telopay',
  [PaymentProviderWithdraw.betlion_afrimoney]: 'Betlion-Afrimoney',
  [PaymentProviderWithdraw.betlion_ekwanza]: 'Betlion-Ekwanza',
  [PaymentProviderWithdraw.betlion_aki]: 'Betlion-Aki',
  [PaymentProviderWithdraw.betlion_paypay]: 'Betlion-PayPay',
  [PaymentProviderWithdraw.betlion_bai_account]: 'Betlion-Atlantico',
  [PaymentProviderWithdraw.betlion_other_bank_account]: 'Betlion-Other-Bank-Account',
  [PaymentProviderWithdraw.betlion_paychangu]: 'Betlion-PayChangu',
  [PaymentProviderWithdraw.aircash_pay]: 'Aircash-Pay',
};

export const DEFAULT_AMOUNT = 20;

// this have styling hard coded in websources/src/components/modules/deposit/index.scss
// export const HTML_3DS_IFRAME_ID = 'deposit-module-iframe-id';
export const HTML_3DS_IFRAME_ID = 'validation3ds';
export const HTML_3DS_IFRAME_WRAPPER = 'deposit-module'; /// fallback to document.body

export const HTML_3DS_HIDDEN_IFRAME_ID = 'hidden3ds';

export const BRIDGER_APPLE_PAY_LOCAL_STORAGE_KEY = 'bridgerApplePayDeposit';
export const BRIDGER_GOOGLE_PAY_LOCAL_STORAGE_KEY = 'bridgerGooglePayDeposit';
export const BRIDGER_CUSTOM_WALLET_LOCAL_STORAGE_KEY = 'bridgerCustomWalletDeposit';

export const TAX_TYPE_DEPOSIT = 2;
export const TAX_TYPE_WITHDRAW = 1;

export const typeCards = {
  visa: 'visa',
  mastercard: 'mastercard',
  maestro: 'maestro',
};

export const WITHDRAWAL_CHANNEL_STATUS_USER_CANNOT_WITHDRAW_KYC = 1;
export const WITHDRAWAL_CHANNEL_STATUS_USER_CAN_WITHDRAW = 2;
export const WITHDRAWAL_CHANNEL_STATUS_USER_CANNOT_WITHDRAW_NO_DEPOSIT = 3;

export const BETLION_DEPOSIT_CHANNELS = 1;
export const BETLION_WITHDRAW_CHANNELS = 2;
